<template>
  <div>
    <DialogBase panel-title="Thông tin chung" panel-subtitle="Vui lòng điền đầy đủ thông tin" panel-icon="el-icon-document-add"
        :visible.sync="dialogVisible"
        size="xl"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="2vh"
        title="Thêm thực đơn"
    >
      <el-form
          label-width="140px"
          label-position="left"
          :model="createMultiClassMenu"
          ref="createTabAllClassMenu"
      >
        <el-tabs type="card" v-model="activeNameTab">
          <el-tab-pane label="Thứ 2" name="monday">
            <div class="table-content row-data">
              <el-table
                  highlight-current-row
                  :data="
                  createMultiClassMenu.createTabAllClassMenu[0]
                    .createTabDayInWeek
                "
                  :header-cell-style="tableHeaderColor"
                  border
              >
                <el-table-column
                    prop="sessionDay"
                    label="Buổi"
                    align="center"
                    width="150px"
                ></el-table-column>
                <el-table-column
                    prop="timeContent"
                    label="Thời gian"
                    align="center"
                    width="150px"
                >
                  <template v-slot:default="scope">
                    <el-input
                        v-model="scope.row.timeContent"
                        placeholder="Nhập thời gian..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="contentClassMenu"
                    label="Nội dung"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        type="textarea"
                        v-model="scope.row.contentClassMenu"
                        :rows="4"
                        placeholder="Nhập thực đơn..."
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column
                    label="Ảnh"
                    align="center"
                    width="150px"
                >
                  <template v-slot:default="scope">
                    <div>
                      <el-upload
                          ref="uploadImageMenu"
                          class="upload_image"
                          :class="{ 'hide-upload': !!scope.row.urlImgMenuWeb }"
                          action="#"
                          list-type="picture-card"
                          :on-preview="handlePictureCardPreview"
                          :on-remove="() => handleRemoveImage(scope.row)"
                          :on-change="(value) => handleChangeImage(scope.row, value)"
                          :auto-upload="false"
                          :multiple="false"
                          accept="image/*"
                          :limit="1"
                      >
                        <template #trigger>
                          <div style="text-align: center;">
                            <i class="el-icon-plus" style="font-size: 16px;"></i>
                            <div style="font-size: 12px; margin-top: 4px; line-height: 1.2;">Thêm ảnh</div>
                          </div>
                        </template>
                      </el-upload>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                    v-if="checkPermission(['studentQuality_menu_update'])"
                    label="Tác vụ"
                    align="center"
                    width="120"
                >
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center; align-items: center; gap: 8px;">
                      <el-tooltip effect="dark" content="Xóa" placement="top">
                      <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteRow(scope.$index, 0)"></el-button>
                    </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <el-tab-pane label="Thứ 3" name="tuesday">
            <div class="table-content row-data">
              <el-table
                  highlight-current-row
                  :data="
                  createMultiClassMenu.createTabAllClassMenu[1]
                    .createTabDayInWeek
                "
                  :header-cell-style="tableHeaderColor"
                  border
              >
                <el-table-column
                    prop="sessionDay"
                    label="Buổi"
                    align="center"
                    width="150px"
                ></el-table-column>
                <el-table-column
                    prop="timeContent"
                    label="Thời gian"
                    align="center"
                    width="150px"
                >
                  <template v-slot:default="scope">
                    <el-input
                        v-model="scope.row.timeContent"
                        placeholder="Nhập thời gian..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="contentClassMenu"
                    label="Nội dung"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        type="textarea"
                        v-model="scope.row.contentClassMenu"
                        placeholder="Nhập thực đơn..."
                        :rows="4"
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column
                    label="Ảnh"
                    align="center"
                    width="150px"
                >
                  <template v-slot:default="scope">
                    <div>
                      <el-upload
                          ref="uploadImageMenu"
                          class="upload_image"
                          :class="{ 'hide-upload': !!scope.row.urlImgMenuWeb }"
                          action="#"
                          list-type="picture-card"
                          :on-preview="handlePictureCardPreview"
                          :on-remove="() => handleRemoveImage(scope.row)"
                          :on-change="(value) => handleChangeImage(scope.row, value)"
                          :auto-upload="false"
                          :multiple="false"
                          accept="image/*"
                          :limit="1"
                      >
                        <template #trigger>
                          <div style="text-align: center;">
                            <i class="el-icon-plus" style="font-size: 16px;"></i>
                            <div style="font-size: 12px; margin-top: 4px; line-height: 1.2;">Thêm ảnh</div>
                          </div>
                        </template>
                      </el-upload>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                    v-if="checkPermission(['studentQuality_menu_update'])"
                    label="Tác vụ"
                    align="center"
                    width="120"
                >
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center; align-items: center; gap: 8px;">
                      <!-- <el-tooltip effect="dark" content="Thêm" placement="top">
                      <el-button size="mini" type="warning" icon="el-icon-plus" circle @click="addRowTableTuesday(scope.row.sessionDay)"></el-button>
                    </el-tooltip> -->
                    <el-tooltip effect="dark" content="Xóa" placement="top">
                      <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteRow(scope.$index, 1)"></el-button>
                    </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <el-tab-pane label="Thứ 4" name="wednesday">
            <div class="table-content row-data">
              <el-table
                  highlight-current-row
                  :data="
                  createMultiClassMenu.createTabAllClassMenu[2]
                    .createTabDayInWeek
                "
                  :header-cell-style="tableHeaderColor"
                  border
              >
                <el-table-column
                    prop="sessionDay"
                    label="Buổi"
                    align="center"
                    width="150px"
                ></el-table-column>
                <el-table-column
                    prop="timeContent"
                    label="Thời gian"
                    align="center"
                    width="150px"
                >
                  <template v-slot:default="scope">
                    <el-input
                        v-model="scope.row.timeContent"
                        placeholder="Nhập thời gian..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="contentClassMenu"
                    label="Nội dung"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        type="textarea"
                        v-model="scope.row.contentClassMenu"
                        placeholder="Nhập thực đơn..."
                        :rows="4"
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column
                    label="Ảnh"
                    align="center"
                    width="150px"
                >
                  <template v-slot:default="scope">
                    <div>
                      <el-upload
                          ref="uploadImageMenu"
                          class="upload_image"
                          :class="{ 'hide-upload': !!scope.row.urlImgMenuWeb }"
                          action="#"
                          list-type="picture-card"
                          :on-preview="handlePictureCardPreview"
                          :on-remove="() => handleRemoveImage(scope.row)"
                          :on-change="(value) => handleChangeImage(scope.row, value)"
                          :auto-upload="false"
                          :multiple="false"
                          accept="image/*"
                          :limit="1"
                      >
                        <template #trigger>
                          <div style="text-align: center;">
                            <i class="el-icon-plus" style="font-size: 16px;"></i>
                            <div style="font-size: 12px; margin-top: 4px; line-height: 1.2;">Thêm ảnh</div>
                          </div>
                        </template>
                      </el-upload>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                    v-if="checkPermission(['studentQuality_menu_update'])"
                    label="Tác vụ"
                    align="center"
                    width="120"
                >
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center; align-items: center; gap: 8px;">
                      <!-- <el-tooltip effect="dark" content="Thêm" placement="top">
                      <el-button size="mini" type="warning" icon="el-icon-plus" circle @click="addRowTableWednesday(scope.row.sessionDay)"></el-button>
                    </el-tooltip> -->
                    <el-tooltip effect="dark" content="Xóa" placement="top">
                      <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteRow(scope.$index, 2)"></el-button>
                    </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <el-tab-pane label="Thứ 5" name="thursday">
            <div class="table-content row-data">
              <el-table
                  highlight-current-row
                  :data="
                  createMultiClassMenu.createTabAllClassMenu[3]
                    .createTabDayInWeek
                "
                  :header-cell-style="tableHeaderColor"
                  border
              >
                <el-table-column
                    prop="sessionDay"
                    label="Buổi"
                    align="center"
                    width="150px"
                ></el-table-column>
                <el-table-column
                    prop="timeContent"
                    label="Thời gian"
                    align="center"
                    width="150px"
                >
                  <template v-slot:default="scope">
                    <el-input
                        v-model="scope.row.timeContent"
                        placeholder="Nhập thời gian..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="contentClassMenu"
                    label="Nội dung"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        type="textarea"
                        v-model="scope.row.contentClassMenu"
                        placeholder="Nhập thực đơn..."
                        :rows="4"
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column
                    label="Ảnh"
                    align="center"
                    width="150px"
                >
                  <template v-slot:default="scope">
                    <div>
                      <el-upload
                          ref="uploadImageMenu"
                          class="upload_image"
                          :class="{ 'hide-upload': !!scope.row.urlImgMenuWeb }"
                          action="#"
                          list-type="picture-card"
                          :on-preview="handlePictureCardPreview"
                          :on-remove="() => handleRemoveImage(scope.row)"
                          :on-change="(value) => handleChangeImage(scope.row, value)"
                          :auto-upload="false"
                          :multiple="false"
                          accept="image/*"
                          :limit="1"
                      >
                        <template #trigger>
                          <div style="text-align: center;">
                            <i class="el-icon-plus" style="font-size: 16px;"></i>
                            <div style="font-size: 12px; margin-top: 4px; line-height: 1.2;">Thêm ảnh</div>
                          </div>
                        </template>
                      </el-upload>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                    v-if="checkPermission(['studentQuality_menu_update'])"
                    label="Tác vụ"
                    align="center"
                    width="120"
                >
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center; align-items: center; gap: 8px;">
                      <!-- <el-tooltip effect="dark" content="Thêm" placement="top">
                      <el-button size="mini" type="warning" icon="el-icon-plus" circle @click="addRowTableThursday(scope.row.sessionDay)"></el-button>
                    </el-tooltip> -->
                    <el-tooltip effect="dark" content="Xóa" placement="top">
                      <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteRow(scope.$index, 3)"></el-button>
                    </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <el-tab-pane label="Thứ 6" name="friday">
            <div class="table-content row-data">
              <el-table
                  highlight-current-row
                  :data="
                  createMultiClassMenu.createTabAllClassMenu[4]
                    .createTabDayInWeek
                "
                  :header-cell-style="tableHeaderColor"
                  border
              >
                <el-table-column
                    prop="sessionDay"
                    label="Buổi"
                    align="center"
                    width="150px"
                ></el-table-column>
                <el-table-column
                    prop="timeContent"
                    label="Thời gian"
                    align="center"
                    width="150px"
                >
                  <template v-slot:default="scope">
                    <el-input
                        v-model="scope.row.timeContent"
                        placeholder="Nhập thời gian..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="contentClassMenu"
                    label="Nội dung"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        type="textarea"
                        v-model="scope.row.contentClassMenu"
                        placeholder="Nhập thực đơn..."
                        :rows="4"
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column
                    label="Ảnh"
                    align="center"
                    width="150px"
                >
                  <template v-slot:default="scope">
                    <div>
                      <el-upload
                          ref="uploadImageMenu"
                          class="upload_image"
                          :class="{ 'hide-upload': !!scope.row.urlImgMenuWeb }"
                          action="#"
                          list-type="picture-card"
                          :on-preview="handlePictureCardPreview"
                          :on-remove="() => handleRemoveImage(scope.row)"
                          :on-change="(value) => handleChangeImage(scope.row, value)"
                          :auto-upload="false"
                          :multiple="false"
                          accept="image/*"
                          :limit="1"
                      >
                        <template #trigger>
                          <div style="text-align: center;">
                            <i class="el-icon-plus" style="font-size: 16px;"></i>
                            <div style="font-size: 12px; margin-top: 4px; line-height: 1.2;">Thêm ảnh</div>
                          </div>
                        </template>
                      </el-upload>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                    v-if="checkPermission(['studentQuality_menu_update'])"
                    label="Tác vụ"
                    align="center"
                    width="120"
                >
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center; align-items: center; gap: 8px;">
                      <!-- <el-tooltip effect="dark" content="Thêm" placement="top">
                      <el-button size="mini" type="warning" icon="el-icon-plus" circle @click="addRowTableFriday(scope.row.sessionDay)"></el-button>
                    </el-tooltip> -->
                    <el-tooltip effect="dark" content="Xóa" placement="top">
                      <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteRow(scope.$index, 4)"></el-button>
                    </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <el-tab-pane label="Thứ 7" name="saturday">
            <div class="table-content row-data">
              <el-table
                  highlight-current-row
                  :data="
                  createMultiClassMenu.createTabAllClassMenu[5]
                    .createTabDayInWeek
                "
                  :header-cell-style="tableHeaderColor"
                  border
              >
                <el-table-column
                    prop="sessionDay"
                    label="Buổi"
                    align="center"
                    width="150px"
                ></el-table-column>
                <el-table-column
                    prop="timeContent"
                    label="Thời gian"
                    align="center"
                    width="150px"
                >
                  <template v-slot:default="scope">
                    <el-input
                        v-model="scope.row.timeContent"
                        placeholder="Nhập thời gian..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="contentClassMenu"
                    label="Nội dung"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        type="textarea"
                        v-model="scope.row.contentClassMenu"
                        placeholder="Nhập thực đơn..."
                        :rows="4"
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column
                    label="Ảnh"
                    align="center"
                    width="150px"
                >
                  <template v-slot:default="scope">
                    <div>
                      <el-upload
                          ref="uploadImageMenu"
                          class="upload_image"
                          :class="{ 'hide-upload': !!scope.row.urlImgMenuWeb }"
                          action="#"
                          list-type="picture-card"
                          :on-preview="handlePictureCardPreview"
                          :on-remove="() => handleRemoveImage(scope.row)"
                          :on-change="(value) => handleChangeImage(scope.row, value)"
                          :auto-upload="false"
                          :multiple="false"
                          accept="image/*"
                          :limit="1"
                      >
                        <template #trigger>
                          <div style="text-align: center;">
                            <i class="el-icon-plus" style="font-size: 16px;"></i>
                            <div style="font-size: 12px; margin-top: 4px; line-height: 1.2;">Thêm ảnh</div>
                          </div>
                        </template>
                      </el-upload>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                    v-if="checkPermission(['studentQuality_menu_update'])"
                    label="Tác vụ"
                    align="center"
                    width="120"
                >
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center; align-items: center; gap: 8px;">
                      <!-- <el-tooltip effect="dark" content="Thêm" placement="top">
                      <el-button size="mini" type="warning" icon="el-icon-plus" circle @click="addRowTableSaturday(scope.row.sessionDay)"></el-button>
                    </el-tooltip> -->
                    <el-tooltip effect="dark" content="Xóa" placement="top">
                      <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteRow(scope.$index, 5)"></el-button>
                    </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>

          <el-tab-pane label="CN" name="sunday">
            <div class="table-content row-data">
              <el-table
                  highlight-current-row
                  :header-cell-style="tableHeaderColor"
                  :data="
                  createMultiClassMenu.createTabAllClassMenu[6]
                    .createTabDayInWeek
                "
                  border
              >
                <el-table-column
                    prop="sessionDay"
                    label="Buổi"
                    align="center"
                    width="150px"
                ></el-table-column>
                <el-table-column
                    prop="timeContent"
                    label="Thời gian"
                    align="center"
                    width="150px"
                >
                  <template v-slot:default="scope">
                    <el-input
                        v-model="scope.row.timeContent"
                        placeholder="Nhập thời gian..."
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                    prop="contentClassMenu"
                    label="Nội dung"
                    align="center"
                >
                  <template v-slot:default="scope">
                    <el-input
                        type="textarea"
                        v-model="scope.row.contentClassMenu"
                        placeholder="Nhập thực đơn..."
                        :rows="4"
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column
                    label="Ảnh"
                    align="center"
                    width="150px"
                >
                  <template v-slot:default="scope">
                    <div>
                      <el-upload
                          ref="uploadImageMenu"
                          class="upload_image"
                          :class="{ 'hide-upload': !!scope.row.urlImgMenuWeb }"
                          action="#"
                          list-type="picture-card"
                          :on-preview="handlePictureCardPreview"
                          :on-remove="() => handleRemoveImage(scope.row)"
                          :on-change="(value) => handleChangeImage(scope.row, value)"
                          :auto-upload="false"
                          :multiple="false"
                          accept="image/*"
                          :limit="1"
                      >
                        <template #trigger>
                          <div style="text-align: center;">
                            <i class="el-icon-plus" style="font-size: 16px;"></i>
                            <div style="font-size: 12px; margin-top: 4px; line-height: 1.2;">Thêm ảnh</div>
                          </div>
                        </template>
                      </el-upload>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column
                    v-if="checkPermission(['studentQuality_menu_update'])"
                    label="Tác vụ"
                    align="center"
                    width="120"
                >
                  <template v-slot:default="scope">
                    <div style="display: flex; justify-content: center; align-items: center; gap: 8px;">
                      <!-- <el-tooltip effect="dark" content="Thêm" placement="top">
                      <el-button size="mini" type="warning" icon="el-icon-plus" circle @click="addRowTableSunday(scope.row.sessionDay)"></el-button>
                    </el-tooltip> -->
                    <el-tooltip effect="dark" content="Xóa" placement="top">
                      <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="deleteRow(scope.$index, 6)"></el-button>
                    </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <div style="margin-top: 50px">
        <el-row type="flex" :gutter="20">
          <el-col :span="12">
            <div class="button-click-left">
              <el-row type="flex" :gutter="10">
                <el-col :span="8">
                  <el-date-picker
                      style="width: 100%"
                      v-model="createTimeClassMenu"
                      type="week"
                      value-format="yyyy-MM-dd"
                      format="Tuần WW"
                      placeholder="Chọn tuần"
                      :clearable="false"
                      @change="getValueDateClassMenu(createTimeClassMenu)"
                  ></el-date-picker>
                </el-col>
                <el-col :span="16">
                  <el-select
                      style="width: 100%"
                      v-model="listCreateTimeClassMenu"
                      multiple
                      @change="changeWeek()"
                      placeholder="Tuần đã chọn"
                  ></el-select>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <el-select
                  v-model="createMultiClassMenu.listIdClass"
                  class="button-left"
                  placeholder="Chọn lớp"
                  :clearable="true"
                  style="width: 100%"
                  :multiple="true"
              >
                <el-option
                    v-for="item in classListCommon"
                    :key="item.id"
                    :label="item.className"
                    :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
      </div>

      <template #footer>
      <div class="tab-infor-button">
        <el-button
            type="danger"
            size="medium"
            @click="closeDialogByButton('createTabAllClassMenu')"
        >
          <i class="el-icon-circle-close" />
          <span>Đóng</span>
        </el-button>
        <el-button
            v-if="checkPermission(['studentQuality_menu_update'])"
            type="success"
            size="medium"
            :loading="loadingButton"
            mini
            @click="submitForm('createTabAllClassMenu')"
        >
          <i class="el-icon-circle-check" />
          <span>Lưu</span>
        </el-button>
      </div>
      </template>
    </DialogBase>
  </div>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import checkPermission from "@/utils/permission.js";
import ClassMenuService from "@/services/ClassMenuService";
import moment from "moment";
import {mapGetters} from "vuex";
export default {
  components: { DialogBase },
  props: {
    dialogVisible: null,
  },
  data() {
    return {
      fileListImage: [],
      createTimeClassMenu: "",
      listTimeClassMenu: "",
      listCreateTimeClassMenu: [],
      activeNameTab: "monday",
      loadingButton: false,
      value: "",
      createMultiClassMenu: {
        createTabAllClassMenu: [
          {
            createTabDayInWeek: [
              {
                sessionDay: "Sáng",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Phụ Sáng",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Trưa",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Chiều",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Phụ Chiều",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Tối",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
            ],
          },
          {
            createTabDayInWeek: [
              {
                sessionDay: "Sáng",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Phụ Sáng",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Trưa",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Chiều",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Phụ Chiều",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Tối",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
            ],
          },
          {
            createTabDayInWeek: [
              {
                sessionDay: "Sáng",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Phụ Sáng",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Trưa",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Chiều",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Phụ Chiều",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Tối",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
            ],
          },
          {
            createTabDayInWeek: [
              {
                sessionDay: "Sáng",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Phụ Sáng",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Trưa",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Chiều",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "PHụ Chiều",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Tối",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
            ],
          },
          {
            createTabDayInWeek: [
              {
                sessionDay: "Sáng",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Phụ Sáng",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Trưa",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Chiều",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Phụ Chiều",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Tối",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
            ],
          },
          {
            createTabDayInWeek: [
              {
                sessionDay: "Sáng",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Phụ Sáng",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Trưa",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Chiều",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Phụ Chiều",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Tối",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
            ],
          },
          {
            createTabDayInWeek: [
              {
                sessionDay: "Sáng",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Phụ Sáng",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Trưa",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Chiều",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Phụ Chiều",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
              {
                sessionDay: "Tối",
                timeContent: "",
                contentClassMenu: "",
                urlImgMenuWeb: "",
              },
            ],
          },
        ],
        weekClassMenu: [],
        listIdClass: [],
      },
    };
  },
  computed:{
    ...mapGetters('classStore',['classListCommon'])
  },
  created() {
    this.$store.dispatch('classStore/fetchDataClassListCommon')
  },
  methods: {
    checkPermission,
    deleteRow(index, day) {
      let a =
          this.createMultiClassMenu.createTabAllClassMenu[day].createTabDayInWeek[
              index
              ];
      a.contentClassMenu = "";
      a.timeContent = "";
    },
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;border:1px solid #fff";
    },
    changeWeek() {
      let c = this.listCreateTimeClassMenu;
      this.createMultiClassMenu.weekClassMenu = [];
      c.forEach((element) => {
        {
          let date = element.slice(-11, -1);
          var newdate = date.split("-").reverse().join("-");
          this.createMultiClassMenu.weekClassMenu.push(newdate);
        }
      });
    },
    closeDialog() {
      this.$refs["createTabAllClassMenu"].resetFields();
      this.$emit("dialog-close");
      this.resetData();
      this.resetUploadImageMenu();
    },
    //click when click button

    closeDialogByButton(fromData) {
      this.$refs[fromData].resetFields();
      this.$emit("dialog-close");
      this.resetData();
      this.resetUploadImageMenu();
    },

    resetData() {
      this.activeNameTab = "monday";
      this.listCreateTimeClassMenu = [];
      this.createMultiClassMenu.listIdClass = "";
      this.createMultiClassMenu.weekClassMenu = [];
      this.createTimeClassMenu = "";
      this.createMultiClassMenu.createTabAllClassMenu.forEach((x) => {
        x.createTabDayInWeek.forEach((y) => {
          y.timeContent = "";
          y.contentClassMenu = "";
        });
      });
    },

    handleClose(done) {
      this.$confirm("Are you sure to close this dialog?")
          .then((_) => {
            console.log(_);
            done();
          })
          .catch((_) => {
            console.log(_);
          });
    },
    submitForm(fromData) {
      if (
          this.createMultiClassMenu.listIdClass.length > 0 &&
          this.createMultiClassMenu.weekClassMenu.length > 0
      ) {
        this.loadingButton = true;
        ClassMenuService.createMultiMenuClass(this.appendFormData())
            .then(() => {
              this.$message({
                message: "Thêm mới thực đơn thành công",
                type: "success",
              });
              setTimeout(() => {
                this.closeDialogByButton(fromData);
              }, 500);
            })
            .catch((err) => {
              this.$message({
                message: "Thêm mới thực đơn thất bại",
                type: "error",
              });

              console.log(err);
            })
            .finally(() => {
              setTimeout(() => {
                this.loadingButton = false;
              }, 500);
            });
      } else {
        this.$message({
          message: "Bạn phải chọn lớp và tuần áp dụng",
          type: "error",
        });
      }
    },

    appendFormData() {
      const formData = new FormData();
      const data = this.createMultiClassMenu;

      data.createTabAllClassMenu.forEach((tabClassMenu, classIndex) => {
        tabClassMenu.createTabDayInWeek.forEach((dayMenu, dayIndex) => {
          formData.append(`createTabAllClassMenu[${classIndex}].createTabDayInWeek[${dayIndex}].sessionDay`, dayMenu.sessionDay);

          if(dayMenu.timeContent) {
            formData.append(`createTabAllClassMenu[${classIndex}].createTabDayInWeek[${dayIndex}].timeContent`, dayMenu.timeContent);
          }

          if (dayMenu.contentClassMenu) {
            formData.append(`createTabAllClassMenu[${classIndex}].createTabDayInWeek[${dayIndex}].contentClassMenu`, dayMenu.contentClassMenu);
          }

          if(dayMenu.urlImgMenuWeb) {
            formData.append(`createTabAllClassMenu[${classIndex}].createTabDayInWeek[${dayIndex}].multipartFile`, dayMenu.urlImgMenuWeb);
          }
        });
      });

      data.listIdClass.forEach((item, index) => {
        formData.append(`listIdClass[${index}]`, item);
      });

      data.weekClassMenu.forEach((item, index) => {
        formData.append(`weekClassMenu[${index}]`, item);
      });

      return formData;
    },

    getValueDateClassMenu(createTimeClassMenu) {
      // Xử lý ngày trả về từ el-date-picker
      const selectedDate = moment(createTimeClassMenu, "YYYY-MM-DD");

      // Lấy ngày đầu tuần (Thứ Hai) và cuối tuần (Chủ Nhật)
      const startOfWeek = selectedDate.startOf("isoWeek").format("DD-MM-YYYY");
      this.createTimeClassMenu = createTimeClassMenu;
      let a = selectedDate.startOf("isoWeek").format("YYYY-MM-DD");

      let weeknumber = moment(a, "YYYY-MM-DD").isoWeek();

      let formatweek =
          "Tuần " + weeknumber + "(từ " + startOfWeek + ")";
      let indexOfFormatWeek = this.listCreateTimeClassMenu.indexOf(formatweek);
      if (indexOfFormatWeek == -1) {
        this.listCreateTimeClassMenu.push(formatweek);
      } else {
        this.listCreateTimeClassMenu.splice(indexOfFormatWeek, 0);
      }
      let indexOfCreateTimeClassMenu =
          this.createMultiClassMenu.weekClassMenu.indexOf(a);
      if (indexOfCreateTimeClassMenu == -1) {
        this.createMultiClassMenu.weekClassMenu.push(a);
      } else {
        this.createMultiClassMenu.weekClassMenu.splice(
            indexOfCreateTimeClassMenu,
            0
        );
      }
    },

    handleChangeImage(row, value) {
      row.urlImgMenuWeb = value?.raw;
    },

    handleRemoveImage(row) {
      row.urlImgMenuWeb = "";
    },

    handlePictureCardPreview(file) {
      console.log(file);
    },

    resetUploadImageMenu() {
      this.fileListImage = [];
      if (this.$refs.uploadImageMenu) {
        if (Array.isArray(this.$refs.uploadImageMenu)) {
          this.$refs.uploadImageMenu.forEach((upload) => {
            if (upload && typeof upload.clearFiles === 'function') {
              upload.clearFiles();
            }
          });
        } else if (typeof this.$refs.uploadImageMenu.clearFiles === 'function') {
          this.$refs.uploadImageMenu.clearFiles();
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-dialog.scss";
/deep/.el-dialog__title {
  font-size: 25px;
  color: #606266;
}
/deep/.el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}
/deep/.el-button--primary {
  width: 100%;
  background: #409eff;
}
/deep/.upload-demo {
  text-align: center;
  .el-upload {
    width: 100%;
  }
}
/deep/.el-avatar {
  display: inline;
  img {
    border-radius: 5px;
    width: 100%;
  }
}
/deep/.el-input.is-disabled .el-input__inner {
  text-align: center;
  color: #d13b93;
  font-weight: bold;
}
.el-select {
  display: block;
}

.tab-infor-button {
  text-align: right;
  margin-top: 20px;
}
.bg-purple {
  background: #d3dce6;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.group-radio-status {
  margin: 0 50px;
  .kids-status {
    margin-bottom: 10px;
  }
}
// /deep/.el-tabs__nav {
//   background: #a0a19ce0;
// }
// /deep/.el-tabs__item {
//   color: white;
// }
// /deep/.el-tabs__item.is-active {
//   color: white;
//   background: #67c23a;
// }
/deep/.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after {
  content: "*";
  color: #f56c6c;
  margin-left: 3px;
}
/deep/.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  color: #f56c6c;
  margin-left: -4px;
}
.table-icon-1 {
  width: 30%;
  margin-left: 15%;
  display: inline-block;
}
.table-icon-2 {
  width: 30%;
  margin-right: 15%;
  float: right;
}

/deep/ .upload_image {
  .el-upload--picture-card {
    width: 80px;
    height: 80px;
    line-height: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
    margin: 0;
  }
}

/deep/ .hide-upload {
  .el-upload--picture-card {
    display: none !important;
  }
}
</style>
